import { actionCreatorFactory } from 'typescript-fsa';
import { ThunkDispatch } from '../../@types/store';
import { User } from '../../@types/user';
import { Endpoints } from '../../apis';
import { setMaintenance } from '../maintenance/maintenance.actions';

const actionCreator = actionCreatorFactory('@@xver/auth');

export const setAuthUser = actionCreator<User | undefined>('setAuthUser');

export const requestAuthUser = () => async (dispatch: ThunkDispatch) => {
    try {
        const user = await Endpoints.v1.Authentication.getUserInfo();

        dispatch(setAuthUser(user));
        dispatch(setMaintenance(false));

        return user;
    } catch (e) {
        console.error(e);
        dispatch(setAuthUser(undefined));

        return undefined;
    }
};
